import axios from '@/utils/axios'

// export const createSalesTransPrice = (payload ) => {
//     return axios.post(`/sales_trans_cost_record`, payload)
// }

export const getSalesStatVol = (payload ) => {
    return axios.get(`/sales_stat_for_vol`, {
        params: payload
    })
}

export const getSalesStatReceive = (payload ) => {
    return axios.get(`/sales_stat_for_receive`, {
        params: payload
    })
}

export const getMySalesStatSum = (payload ) => {
    return axios.get(`/my_sales_stat_sum`, {
        params: payload
    })
}

export const getStatViewB = (payload ) => {
    return axios.get(`/stat_view_B`, {
        params: payload
    })
}

export const getStatViewC = (payload ) => {
    return axios.get(`/stat_view_C`, {
        params: payload
    })
}

export const postSalesStatVol = (data) => {
    return axios.post(`/sales_stat_for_vol`, data)
}

export const postSalesStatReceive = (data) => {
    return axios.post(`/sales_stat_for_receive`, data)
}

export const addReceiveTask = (id, data) => {
  return axios.put(`/add_receive_task/${id}`, data)
}

export const setReceiveTask = (id, data) => {
  return axios.put(`/set_receive_task/${id}`, data)
}

export const autoSetReceiveTask = (data) => {
  return axios.post(`/auto_set_receive_task`, data)
}

export const getDuiZhangDan = (payload) => {
  return axios.get(`/get_duizhangdan`, {
        params: payload
    })
}